<template>
    <div class="container" ref="section">
        <div class="row">
            <div class="text-center fs-1 pt-5 pb-4 text-uppercase oswald-bold">
               Current Company Members
            </div>
            <div v-for="(member, index) in showsData" :key="member.id"
                :ref="el => { if (el) cardRefs[index] = el }"
                class="col-md-3 d-flex flex-column align-items-center justify-content-start pb-3 px-sm-2 px-5 member-card"
                :class="{ 'member-card-visible': visibleCards[index] }"
                :style="{ '--member-delay': (index % 4) * 0.12 + 's' }">

                <img :src="`${$API_ASSETS}${member.headshot.id}.png`" class="img-fluid py-2 w-100 px-2" />
                <div class="text-start px-3">
                    <span class="fs-3 text-uppercase oswald-bold">{{ member.name }}</span>
                    <span class="fs-6 d-block open-sans">{{ member.bio }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'MembersSection',
    data() {
        return {
            showsData: [],
            visibleCards: [],
            cardRefs: [],
        };
    },
    beforeUnmount() {
        if (this._observer) this._observer.disconnect();
    },
    methods: {
        async fetchShowData() {
            const url = this.$API_GRAPHQL;
            try {
                const response = await axios.post(url, {
                    query: `
                       query {
                            company_member(filter:{ hidden:{_eq:false}}) {
                                id
                                initials
                                name
                                bio
                                headshot {
                                    id
                                }
                            }
                        }
                    `
                }, {
                    headers: {
                        'Authorization': `Bearer Pm4Nd5_e46HaK2xtkPcla2PMBzbk9AQf`,
                        'Content-Type': 'application/json'
                    }
                });

                this.showsData = response.data.data.company_member.sort((a, b) => a.name.localeCompare(b.name));
                this.visibleCards = new Array(this.showsData.length).fill(false);

                this.$nextTick(() => {
                    this._observer = new IntersectionObserver((entries) => {
                        entries.forEach(entry => {
                            if (entry.isIntersecting) {
                                const idx = parseInt(entry.target.dataset.memberIndex);
                                this.visibleCards = this.visibleCards.map((v, i) => i === idx ? true : v);
                                this._observer.unobserve(entry.target);
                            }
                        });
                    }, { threshold: 0.2, rootMargin: '0px 0px -40px 0px' });

                    this.cardRefs.forEach((el, idx) => {
                        if (el) {
                            el.dataset.memberIndex = idx;
                            this._observer.observe(el);
                        }
                    });
                });
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
    },
    created() {
        this.fetchShowData();
    },
};

</script>

<style scoped>
.member-card {
    opacity: 0;
    transform: translateY(32px);
    transition: opacity 1.1s ease, transform 1.1s ease;
    transition-delay: var(--member-delay, 0s);
}

.member-card.member-card-visible {
    opacity: 1;
    transform: translateY(0);
}
</style>
